import { useState } from "react";
import "./challenge-report-question-item.css";
import { BiDownArrow, BiUpArrow } from "react-icons/bi";
import { FaUser } from "react-icons/fa";
import { BsCheck2Circle } from "react-icons/bs";
import { SlClose } from "react-icons/sl";
//
import { convertDuration } from "../../../../../core/utils/helpers";

const ChallengeReportQuestionItem = () => {
  const [isOpen, setIsOpen] = useState(false);

  const points = null;
  const timing = null;
  const random_answer_order = null;
  const qv_answers = [1, 2, 3];

  return (
    <div
      className={
        isOpen ? "challenge-report-item height-auto" : "challenge-report-item"
      }
    >
      <div className="c-r-i-header">
        <span className="span-question">Question 1</span>
        <div className="ticks">
          <span>Success rate</span>
          <span>50%</span>
        </div>
        <div className="ticks">
          <span>Best score</span>
          <span>30 Points in 5 seconds</span>
        </div>
        <span className="span-icon" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? (
            <BiUpArrow className="icon" />
          ) : (
            <BiDownArrow className="icon" />
          )}
        </span>
      </div>
      <div className="c-r-i-content">
        <div className="row">
          <span className="span-label">Type :</span>
          <span className="span-mark">
            {/* {"OCA" === "OCA" && "Once Choice Answer"} */}
            {"MCA" === "MCA" && "Multiple Choice Answers"}
            {/* {type === "FIB" && "Fill in the Blanks"} */}
          </span>
        </div>
        <div className="row">
          <span className="span-label">Points :</span>
          <span className="span-mark">{points || 0} Points</span>
        </div>
        <div className="row">
          <span className="span-label">Duration :</span>
          <span className="span-mark">{convertDuration(timing || 5)}</span>
        </div>
        <div className="row">
          <span className="span-label">Random Order of Answers :</span>
          <span className="span-mark">
            {random_answer_order ? "Yes" : "No"}
          </span>
        </div>
        {/* {qv_cover_audio && (
          <div className="w-full mb-md mt-md">
            <audio
              className="w-full"
              controls
              controlsList="nodownload"
              onContextMenu={(e) => e.preventDefault()}
            >
              <source
                src={
                  !isDisplayLanguage
                    ? URL.createObjectURL(qv_cover_audio)
                    : `${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}/storage/audios/${qv_cover_audio}`
                }
                type={qv_cover_audio?.type}
              />
            </audio>
          </div>
        )}
        {qv_cover_image && (
          <div className="w-full mt-xs mb-xs" style={{ textAlign: "center" }}>
            <img
              src={
                !isDisplayLanguage
                  ? URL.createObjectURL(qv_cover_image)
                  : `${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}/storage/images/${qv_cover_image}`
              }
              alt="cover question illustration"
              style={{ maxWidth: "100%" }}
              onContextMenu={(e) => e.preventDefault()}
            />
          </div>
        )} */}
        <div className="col mb-lg">
          <span>Question text</span>
          <hr />
          <p
            dangerouslySetInnerHTML={{
              __html: "qv_description",
            }}
          />
        </div>
        <div className="col mb-lg">
          <span>Question Explanations</span>
          <hr />
          <p
            dangerouslySetInnerHTML={{
              __html: "qv_explanations",
            }}
          />
        </div>
        <div className="answers-wrapper">
          {qv_answers?.map((answer, idx) => {
            return (
              <div className="ans-item-wr w-full d-flex gap-xs" key={idx}>
                <div
                  className={
                    answer?.is_correct
                      ? "answer-item is-good"
                      : "answer-item is-wrong"
                  }
                >
                  {answer?.is_correct ? (
                    <span>
                      <BsCheck2Circle className="icon" />
                    </span>
                  ) : (
                    <span>
                      <SlClose className="icon" />
                    </span>
                  )}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: answer?.answer,
                    }}
                  />
                </div>
                <div className="w-40">
                  <div className="w-full d-flex justify-space-between">
                    <div className="row">
                      <FaUser className="icon" />
                      <span>Playername</span>
                    </div>
                    <span>10 points in 2 minutes</span>
                  </div>
                  <div className="w-full d-flex justify-space-between">
                    <div className="row">
                      <FaUser className="icon" />
                      <span>Playername</span>
                    </div>
                    <span>10 points in 2 minutes</span>
                  </div>
                  <div className="w-full d-flex justify-space-between">
                    <div className="row">
                      <FaUser className="icon" />
                      <span>Playername</span>
                    </div>
                    <span>10 points in 2 minutes</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ChallengeReportQuestionItem;
